export default [
    {
        path: '/lugares-operacion',
        name: 'manager.lugares-operacion',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/lugaresOperacion').then(m => m.default || m),
    }
]